import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import SectionDetails from '../../_Sections/SectionDetails';
import SectionGallery from '../../_Sections/SectionGallery';
import SectionDropship from '../../_Sections/SectionDropship';
import SectionPairings from '../../_Sections/SectionPairings';
import SectionBranding from '../../_Sections/SectionBranding';
import SectionSizes from '../../_Sections/SectionSizes';
import { useSelector } from 'react-redux';
import WebsiteStore from '../../../WebsiteStore';
import { styled } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import SectionPricing from '../../_Sections/SectionPricing';
import tKey from '../../../Common/Utils/tKey';
import { useAppSelector } from '../../../Common/_hooks/useAppSelector';
import ProductSEO from '../../_Sections/ProductSEO';

const PRODUCT_ID = 35;
const VIEW_PRODUCT_ID = 35;

export default function BodyconDressPage() {
  const [t] = useTranslation('page/products/bodycon-dress');
  const productData = useAppSelector(state => state.get('appData').get('products').get(String(PRODUCT_ID)));
  const locale = useAppSelector(state => state.get('userData').get('prefs').get('lang'))

  if (!productData) return null

  return <div className="centered-page product-page-v4">
    <ProductSEO
      viewProductId={VIEW_PRODUCT_ID}
      title={t('Custom all-over print Bodycon Dress | Products')}
      description={t('Design and create your own custom printed Bodycon Dress. ✔ Print-on-demand drop shipping ✔ No minimums ✔ Made in Canada')}
    />
    <SectionDetails
      viewProductId={VIEW_PRODUCT_ID}
      color="#68a9f5"
      bgStyle={{
        backgroundPosition: 'bottom right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '47%',
      }}
      tag={t('The all-over print')}
      title={t('Bodycon Dress')}
      text={t('Turn heads in custom all-over print bodycon dresses made on-demand in Montreal, Canada. With a sculpted silhouette, plunging neckline, and mid-thigh hem, each dress is cut from ultrasoft Luxeform fabric that hugs and flatters. Eye-catching, permanent prints make every design feel bold, original, and unforgettable.')}
      createUrl={productData.get('url_slug') + '?option_fabric=performance-knit'}
      img={require('@resources/img/pages/products/bodycon-dress/banner-1-' + locale + '.png')}
      alt={t('Picture of Bodycon Dress')}
      details={[
        {
          img: require('@resources/img/pages/products/bodycon-dress/icon-1.svg?url'),
          alt: t('icon'),
          text: t('Body-hugging dress with low neckline'),
        },
        {
          img: require('@resources/img/pages/products/bodycon-dress/icon-2.svg?url'),
          alt: t('icon'),
          text: t('Made from Luxeform performance fabric: combining the power of spandex with lightness and comfort'),
        },
        {
          img: require('@resources/img/pages/products/bodycon-dress/icon-3.svg?url'),
          alt: t('icon'),
          text: t('Falls mid-thigh'),
        },
        {
          img: require('@resources/img/pages/products/bodycon-dress/icon-4.svg?url'),
          alt: t('icon'),
          text: t('Vibrant, permanent prints won’t fade with use or washing'),
        },
        {
          img: require('@resources/img/pages/products/bodycon-dress/icon-5.svg?url'),
          alt: t('icon'),
          text: t('Digitally printed on demand in Montreal, Canada'),
        },
      ]}
    />
    <SectionGallery images={[
      require('@resources/img/pages/products/bodycon-dress/gallery_0.jpg'),
      require('@resources/img/pages/products/bodycon-dress/gallery_1.jpg'),
      require('@resources/img/pages/products/bodycon-dress/gallery_2.jpg'),
      require('@resources/img/pages/products/bodycon-dress/gallery_3.jpg'),
      require('@resources/img/pages/products/bodycon-dress/gallery_4.jpg'),
    ]} />

    <SectionDropship
      title={<Trans
        t={t}
        i18nKey={tKey('<yellow>Drop ship</yellow> your athletic<br/>crop top <pink>on-demand</pink>')}
        components={{
          yellow: <span className="ty" />,
          pink: <span className="tp" />,
        }}
      />}
      text={t('Your brand and following will love Bodycon Dresss! At prices designed for reselling, Bodycon Dress made on demand meet the needs of sellers who prefer not to stock inventory. Sell them in your eCommerce store and decide your profit margin.')}
    />

    <SectionPricing
      productId={PRODUCT_ID}
      options={['performance-knit']}
    />

    <SectionSizes
      chart="full"
      productId={PRODUCT_ID}
      title={t('Bodycon Dress Sizing')}
      text={t('There may be some variations in product measurements within or between orders. Each garment is individually cut and sewn which can lead to minor differences in measurements. Measurements are body measurements that correspond with the garment size in US standard sizing. For in between sizes, we recommend choosing the larger size.')}
    />

    <SectionBranding
      hasLabel
      title={t('Brand your Bodycon Dress')}
      text={t('Branding enhances your products. Add custom labels, artist cards or stickers to your packages to create a cohesive message and build your brand.')}
    />

    <SectionPairings
      text={t('Pair your Bodycon Dress with these great products to create your own unique styles.')}
      productSlugs={['draped-kimono-silk-habotai', 'kimono-robe-peachskin', 'silk-charmeuse-scarves']}
    />
  </div>
}